import { render, staticRenderFns } from "./indexOutsourcing.vue?vue&type=template&id=228d94fa&scoped=true"
import script from "./indexOutsourcing.vue?vue&type=script&lang=js"
export * from "./indexOutsourcing.vue?vue&type=script&lang=js"
import style0 from "./indexOutsourcing.vue?vue&type=style&index=0&id=228d94fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228d94fa",
  null
  
)

export default component.exports